module.exports = __webpack_public_path__ + "media/images/area/maps/kanto-52c8019c1006629ae2939ea0011bc1ef.svg";